module.exports = __webpack_public_path__ + "static/turmeric-a1aa34c9d7d27b087792dcd48995ca27.svg";